import { EmptyState, t } from '@kanbios/ui';
import type { maintenance } from '@kanbios/api-client';
import { ObligationBadges } from '../../components/Inventory';
import { IndexList, stateColumn, ViewEmpty } from '../../components/IndexList';
import { useSession } from '../../lib/session';

type Row = maintenance.components['schemas']['ClientRow'];
const OPEN_VIEWS = ['incident', 'to_update', 'maintenance', 'unknown'];

/**
 * Clients (SPEC-005): « N clients sur M ont un sujet ouvert » in the scope; no
 * creation here, a client is born in the Nouveau projet wizard (RG-005-10).
 */
export function ClientsPage() {
  const { enums } = useSession();
  const label = (list: { value: string; label: string }[], value: string) => list.find(i => i.value === value)?.label ?? value;
  return (
    <IndexList<Row>
      id="clients"
      title={t('clients.title')}
      // D54: a client with an open issue is one whose production is not OK (its state views but OK and « Pas en production »).
      subtitle={data => (data ? t('clients.subtitleCount', { n: OPEN_VIEWS.reduce((n, v) => n + (data.views[v] ?? 0), 0), total: data.outOf }) : t('clients.subtitle'))}
      search={t('clients.search')}
      rowHref={r => `/clients/${encodeURIComponent(r.name)}`}
      columns={[
        stateColumn<Row>(enums),
        { key: 'name', label: t('clients.columns.name'), pinned: 'left', minWidth: 220, grow: true, sortable: true, render: r => r.title },
        { key: 'team', label: t('clients.columns.team'), width: 150 },
        { key: 'projects', label: t('clients.columns.projects'), align: 'right', width: 110, sortable: true },
        { key: 'dedicatedServers', label: t('clients.columns.dedicatedServers'), align: 'right', width: 150 },
        { key: 'obligations', label: t('clients.columns.obligations'), width: 160, render: r => <ObligationBadges obligations={r.obligations} /> },
        { key: 'openIssues', label: t('clients.columns.openIssues'), align: 'right', width: 150, sortable: true },
      ]}
      facets={[
        { key: 'state', label: t('inventory.filters.state') },
        { key: 'obligation', label: t('inventory.filters.obligation'), valueLabel: v => label(enums.obligations, v) },
        { key: 'team', label: t('inventory.filters.team') },
      ]}
      emptyFor={(view, setView) =>
        view !== 'all'
          ? <ViewEmpty list="clients" view={view} icon="business" onSeeAll={() => setView('all')} />
          : <EmptyState framed={false} icon="business" title={t('inventory.noResult')} />}
    />
  );
}
